import api from '..'

const allCoursesList = () => {
  return api.get('courses/all').then(({ data }) => {
    return data.data.map(({ attributes }: any) => attributes)
  })
}

export default allCoursesList
